import React from "react";
import Card from "./Card";
import CogniseAiArt from "../../assets/images/CogniseAiArt.png"; // Example image for all cards
import { Link } from "react-router-dom";

export default function CardList() {
  const items = [
    { name: "Face Swap", id: "1483.2454.1861", link: "faceswap" },
    { name: "AI Avatar", id: "1483.2454.1862", link: "ai-avatar" },
  ];

  return (
    <div className="container mx-auto mb-[104px] mt-[40px] grid grid-cols-2 gap-x-[35px] gap-y-[35px] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {items.map((item, index) => (
        <Link to={item.link}>
          <Card
            key={index}
            title={item.name}
            idNumber={item.id}
            imageSrc={CogniseAiArt}
          />
        </Link>
      ))}
    </div>
  );
}
